import { PickersLayout } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { FormInputProps } from './InputInterface';
import { FormControl, FormHelperText } from '@mui/material';

const StyledPickersLayout = styled(PickersLayout)((props) => ({
  '.MuiButtonBase-root:focus, .MuiPickersYear-yearButton:focus': {
    outline: 'none',
  },
  '.MuiDateCalendar-root .MuiPickersDay-root.Mui-selected': {
    backgroundColor: props.theme.colors.primaryColor,
    outline: 'none',
  },
  '.MuiPickersDay-root:not(.Mui-selected)': {
    borderColor: props.theme.colors.primaryColor,
  },
  '.MuiButtonBase-root.Mui-selected': {
    backgroundColor: props.theme.colors.primaryColor,
  },
}));

const DabaduDatePicker = styled(FormControl)`
  &.MuiFormControl-root {
    width: 100%;
  }
  & .MuiInputBase-input {
    font-family: ${(props) => props.theme.fonts.primary};
    color: ${(props) => props.theme.colors.textColor};
    height: auto;
    padding: 18px 20px;

    @media (max-width: 1650px) {
      padding: 12px 14px;
    }
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.colors.inputBorder};
  }
  & .MuiOutlinedInput-root {
    &:hover,
    &:active {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) => props.theme.colors.inputBorder};
      }
    }
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: ${(props) => props.theme.colors.inputBorder};
      }
    }
  }
  & .MuiButtonBase-root {
    &:focus {
      outline: none;
    }
  }
`;

export const DateInput = ({
  name,
  control,
  label,
  rules,
  triggerValidationForField,
  minDate,
  maxDate,
}: FormInputProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DabaduDatePicker required={Boolean(rules)} error={Boolean(rules)}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { onChange, value }, formState: { errors } }) => (
            <>
              {label && <label className='control-label'>{label}</label>}
              <DatePicker
                disableFuture
                value={new Date(value)}
                minDate={minDate}
                maxDate={maxDate}
                onChange={(val) => {
                  onChange(val);
                  triggerValidationForField(name);
                }}
                slots={{
                  layout: StyledPickersLayout,
                }}
                slotProps={{
                  field: { clearable: true, onClear: () => {} },
                }}
                format='MM/dd/yyyy'
              />
              {errors?.[name] && <FormHelperText>{errors?.[name]?.message}</FormHelperText>}
            </>
          )}
        />
      </DabaduDatePicker>
    </LocalizationProvider>
  );
};
